import React from "react";

const WIDTHS = ["w-3/4", "w-1/2", "w-5/6", "w-2/3"];

interface TableSkeletonProps {
  columns: number;
  rows?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <tr key={rowIndex} aria-hidden>
        {Array.from({ length: columns }).map((_, columnIndex) => (
          <td key={columnIndex} className="px-3 py-5">
            <div
              className={`bg-cream-300 dark:bg-cream-700 h-4 ${WIDTHS[(rowIndex + columnIndex) % WIDTHS.length]} animate-pulse rounded`}
            />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default TableSkeleton;
